var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkageSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12866_23090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3637 18L11.4318 18.9319C10.5856 19.7645 9.44467 20.2289 8.25756 20.2241C7.07044 20.2192 5.93332 19.7455 5.0939 18.9061C4.25447 18.0667 3.78075 16.9295 3.77592 15.7424C3.77108 14.5553 4.23553 13.4144 5.06809 12.5681L7.3284 10.3125C8.13917 9.50011 9.22972 9.0282 10.377 8.99335C11.5242 8.9585 12.6414 9.36333 13.5 10.125",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6363 6.00003L12.5681 5.06815C13.4144 4.23559 14.5553 3.77114 15.7424 3.77598C16.9295 3.78081 18.0666 4.25453 18.9061 5.09396C19.7455 5.93338 20.2192 7.0705 20.224 8.25762C20.2289 9.44473 19.7644 10.5857 18.9319 11.4319L16.6716 13.6922C15.8602 14.504 14.7693 14.975 13.6221 15.009C12.4749 15.043 11.358 14.6373 10.5 13.875",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12866_23090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkageSettingsIcon);
export default __webpack_public_path__ + "static/media/linkageSettingsIcon.a7d865f807eb65654601aa2716b24d1f.svg";
export { ForwardRef as ReactComponent };